import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-img-modal',
	templateUrl: './img-modal.component.html',
	styleUrl: './img-modal.component.scss'
})
export class ImgModalComponent {
	constructor(private config: DynamicDialogConfig) {}

	imgSrc: string = '';

	ngOnInit() {
		this.imgSrc = this.config.data.imgFull;
	}
}
